<template>
    <div>
      <div class="text-center my-5" v-if="$store.state.healthyHabits.chart.measurable">
        <h4 :style="{color: $store.state.healthyHabits.chart.color}">{{$t('goal')}}</h4>
        <div class="my-4" v-if="showDailyProgressBar">
          <h5>{{$t('day')}}</h5>
          <b-progress class="b-progress-statistics" show-progress :max="$store.state.healthyHabits.chart.goal">
              <b-progress-bar :style="{'background-color': $store.state.healthyHabits.chart.color}" :value="getBarTotalCountDay"><strong>{{ getBarTotalCountDay }}</strong></b-progress-bar>
              <b-progress-bar variant="info" :value="$store.state.healthyHabits.chart.goal - getBarTotalCountDay"><strong>{{ getBarValueFixed($store.state.healthyHabits.chart.goal - getBarTotalCountDay) }}</strong></b-progress-bar>
          </b-progress>
        </div>
        <div class="my-4" v-if="showWeeklyProgressBar">
          <h5>{{$t('week')}}</h5>
          <b-progress class="b-progress-statistics" show-progress :max="getWeeklyMaxGoal">
              <b-progress-bar :style="{'background-color': $store.state.healthyHabits.chart.color}" :value="getBarTotalCountWeek"><strong>{{ getBarTotalCountWeek }}</strong></b-progress-bar>
              <b-progress-bar variant="info" :value="getWeeklyMaxGoal - getBarTotalCountWeek"><strong>{{ getBarValueFixed(getWeeklyMaxGoal - getBarTotalCountWeek) }}</strong></b-progress-bar>
          </b-progress>
        </div>
        <div class="my-4" v-if="showMonthlyProgressBar">
          <h5>{{$t('month')}}</h5>
          <b-progress class="b-progress-statistics" show-progress :max="getMonthlyMaxGoal">
              <b-progress-bar :style="{'background-color': $store.state.healthyHabits.chart.color}" :value="getBarTotalCountMonth"><strong>{{ getBarTotalCountMonth }}</strong></b-progress-bar>
              <b-progress-bar variant="info" :value="getMonthlyMaxGoal - getBarTotalCountMonth"><strong>{{ getBarValueFixed(getMonthlyMaxGoal - getBarTotalCountMonth) }}</strong></b-progress-bar>
          </b-progress>
        </div>
        <div class="my-4">
          <h5>{{$t('year')}}</h5>
          <b-progress class="b-progress-statistics" show-progress :max="getYearlyMaxGoal">
              <b-progress-bar :style="{'background-color': $store.state.healthyHabits.chart.color}" :value="getBarTotalCountYear"><strong>{{ getBarTotalCountYear }}</strong></b-progress-bar>
              <b-progress-bar variant="info" :value="getYearlyMaxGoal - getBarTotalCountYear"><strong>{{ getBarValueFixed(getYearlyMaxGoal - getBarTotalCountYear) }}</strong></b-progress-bar>
          </b-progress>
        </div>
      </div>
      <div class="text-center my-5">
        <h4 :style="{color: $store.state.healthyHabits.chart.color}">{{$t('summary')}}</h4>
        <div class="pie no-round" :style="{'--p': $store.state.healthyHabits.chart.score.currentValue, '--c': $store.state.healthyHabits.chart.color, '--b': '10px', color: $store.state.healthyHabits.chart.color}">{{$store.state.healthyHabits.chart.score.currentValue}}%</div>
        <div :class="{'inline-block': !showMobileStreaks}">
          <span class="mr-2">{{$t('remaining')}}: <span :style="{color: $store.state.healthyHabits.chart.color, 'font-weight': 'bold'}">{{100-$store.state.healthyHabits.chart.score.currentValue}}%</span></span>
          <span>{{$t('total')}}: <span :style="{color: $store.state.healthyHabits.chart.color, 'font-weight': 'bold'}">{{$store.state.healthyHabits.chart.total}} {{$t('days')}}</span></span>
        </div>
        <div v-if="showMobileStreaks">
          <span class="mr-2">{{$t('currentStreak')}}: <span :style="{color: $store.state.healthyHabits.chart.color, 'font-weight': 'bold'}">{{$store.state.healthyHabits.chart.dataMapped.currentStreak}}</span></span>
          <span>{{$t('bestStreak')}}: <span :style="{color: $store.state.healthyHabits.chart.color, 'font-weight': 'bold'}">{{$store.state.healthyHabits.chart.dataMapped.bestStreak}}</span></span>
          <div class="mt-3">
            <div>{{$t('totalWeek')}}: <span :style="{color: $store.state.healthyHabits.chart.color, 'font-weight': 'bold'}">{{getTotalCountWeek()}} ({{getTotalCountWeek(null, true)}}%)</span></div>
            <div>{{$t('totalMonth')}}: <span :style="{color: $store.state.healthyHabits.chart.color, 'font-weight': 'bold'}">{{getTotalCountMonth()}} ({{getTotalCountMonth(null, true)}}%)</span></div> 
            <div>{{$t('totalYear')}}: <span :style="{color: $store.state.healthyHabits.chart.color, 'font-weight': 'bold'}">{{getTotalCountYear()}} ({{getTotalCountYear(null, true)}}%)</span></div> 
          </div>
        </div>
      </div>
      <healthy-habits-calendar></healthy-habits-calendar>
      <div v-if="Object.keys(this.$store.state.healthyHabits.chart.score.options).length > 0" class="my-5">
        <div class="interval-selector-container">
          <b-form-select class="interval-selector" v-model="$store.state.healthyHabits.chart.score.interval" :options="intervalOptionsScore" @change="scoreIntervalSelected"></b-form-select>
        </div>
        <healthy-habits-chart :key="`score-chart-${$store.state.healthyHabits.chart.score.key}`" showIntervalArrows :chartOptions="$store.state.healthyHabits.chart.score.options"></healthy-habits-chart>
      </div>
      <div v-if="Object.keys(this.$store.state.healthyHabits.chart.history.options).length > 0" class="my-5">
        <div class="interval-selector-container">
          <b-form-select class="interval-selector" v-model="$store.state.healthyHabits.chart.history.interval" :options="intervalOptions" @change="historyIntervalSelected"></b-form-select>
        </div>
        <healthy-habits-chart :key="`history-chart-${$store.state.healthyHabits.chart.history.key}`" showIntervalArrows class="my-5" :chartOptions="$store.state.healthyHabits.chart.history.options"></healthy-habits-chart>
      </div>
      <healthy-habits-chart v-if="Object.keys(this.$store.state.healthyHabits.chart.frequency.options).length > 0" class="my-5" :chartOptions="$store.state.healthyHabits.chart.frequency.options"></healthy-habits-chart>
    </div>
</template>

<script>
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'
import HealthyHabitsChart from '@/components/views/healthy-habits/HealthyHabitsChart'
import { BProgress, BProgressBar, BFormSelect, BTable } from 'bootstrap-vue'
import { DAILY_GOAL, WEEKLY_GOAL, MONTHLY_GOAL } from '@/constants/healthyHabits'
import BaseButton from '@/components/base/buttons/BaseButton'
import HealthyHabitsCalendar from '@/components/views/healthy-habits/HealthyHabitsCalendar'

export default {
   name: 'healthyHabitsStatisticsComponents',
   props: {
   },
   components: {
    HealthyHabitsChart,
    BProgress,
    BProgressBar,
    BFormSelect,
    BTable,
    BaseButton,
    HealthyHabitsCalendar
   },
   created () {
   },
   computed: {
    showDailyProgressBar () {
      return this.$store.state.healthyHabits.chart.goalFrequencyId === DAILY_GOAL
    },
    showWeeklyProgressBar () {
      return this.$store.state.healthyHabits.chart.goalFrequencyId === DAILY_GOAL || this.$store.state.healthyHabits.chart.goalFrequencyId === WEEKLY_GOAL
    },
    showMonthlyProgressBar () {
      return this.$store.state.healthyHabits.chart.goalFrequencyId === DAILY_GOAL || this.$store.state.healthyHabits.chart.goalFrequencyId === WEEKLY_GOAL || this.$store.state.healthyHabits.chart.goalFrequencyId === MONTHLY_GOAL
    },
    getWeeklyMaxGoal () {
      return this.$store.state.healthyHabits.chart.goalFrequencyId === DAILY_GOAL ? this.$store.state.healthyHabits.chart.goal * 7 : this.$store.state.healthyHabits.chart.goal
    },
    getMonthlyMaxGoal () {
      let daysInMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate()
      return this.$store.state.healthyHabits.chart.goalFrequencyId === DAILY_GOAL ? this.$store.state.healthyHabits.chart.goal * daysInMonth : this.$store.state.healthyHabits.chart.goalFrequencyId === WEEKLY_GOAL ? (((daysInMonth * this.$store.state.healthyHabits.chart.goal) / 7) % 1 === 0 ? ((daysInMonth * this.$store.state.healthyHabits.chart.goal) / 7) : ((daysInMonth * this.$store.state.healthyHabits.chart.goal) / 7).toFixed(2)) : this.$store.state.healthyHabits.chart.goal
    },
    getYearlyMaxGoal () {
      let daysInYear = this.daysInYear()
      return this.$store.state.healthyHabits.chart.goalFrequencyId === DAILY_GOAL ? this.$store.state.healthyHabits.chart.goal * daysInYear : this.$store.state.healthyHabits.chart.goalFrequencyId === WEEKLY_GOAL ? (((daysInYear * this.$store.state.healthyHabits.chart.goal) / 7) % 1 === 0 ? ((daysInYear * this.$store.state.healthyHabits.chart.goal) / 7) : ((daysInYear * this.$store.state.healthyHabits.chart.goal) / 7).toFixed(2)) : this.$store.state.healthyHabits.chart.goal * 12
    },
    getBarTotalCountDay () {
      let data = this.$store.state.healthyHabits.chart.dataMapped[this.getDateOnlyFormatted(new Date())] || 0
      let goal = this.$store.state.healthyHabits.chart.dataMapped.goal
      if (data > goal) {
        let partial = (data - goal) % 1 === 0 ? data - goal : (data - goal).toFixed(2)
        return `${goal} + ${partial} ${this.$t('extra')}`
      } else {
        return data
      }
    },
    getBarTotalCountWeek () {
      /*eslint-disable*/
      let data = this.$store.state.healthyHabits.chart.dataMapped
      let dataKeys = Object.keys(data)
      let inputDate = this.getCurrentDateUtc()
      let inputDateDay = inputDate.getDay() === 0 ? 6 : inputDate.getDay() - 1
      let endDate = new Date(inputDate).setDate(inputDate.getDate() + (6 - inputDateDay))
      if (endDate > inputDate) {
        endDate = new Date(inputDate)
      }
      let currentDate = new Date(inputDate.setDate(inputDate.getDate() - inputDateDay))
      let result = dataKeys.reduce((acc, date) => { if (this.checkValidDate(date) && data[date] && currentDate <= new Date(date) && new Date(date) <= endDate) { return data.measurable ? acc += data[date] : acc += 1 } else { return acc } }, 0)
      if (result > this.getWeeklyMaxGoal) {
        let partial = (result - this.getWeeklyMaxGoal) % 1 === 0 ? result - this.getWeeklyMaxGoal : (result - this.getWeeklyMaxGoal).toFixed(2)
        return `${this.getWeeklyMaxGoal} + ${partial} ${this.$t('extra')}`
      } else {
        return result
      }
    },
    getBarTotalCountMonth () {
      let data = this.$store.state.healthyHabits.chart.dataMapped
      let dataKeys = Object.keys(data)
      let firstMonthDate = new Date(new Date().setDate(1)).setHours(0, 0, 0, 0)
      let currentMonth = this.getDateOnlyFormatted(firstMonthDate).split('-')[1]
      let currentYear = this.getDateOnlyFormatted(firstMonthDate).split('-')[0]
      let lastMonthDate = new Date(new Date(currentYear, currentMonth, 0).setHours(0, 0, 0, 0))
      let result = dataKeys.reduce((acc, date) => { if (this.checkValidDate(date) && data[date] && firstMonthDate <= new Date(date) && new Date(date) <= lastMonthDate) { return data.measurable ? acc += data[date] : acc += 1 } else { return acc } }, 0)
      if (result > this.getMonthlyMaxGoal) {
        let partial = (result - this.getMonthlyMaxGoal) % 1 === 0 ? result - this.getMonthlyMaxGoal : (result - this.getMonthlyMaxGoal).toFixed(2)
        return `${this.getMonthlyMaxGoal} + ${partial} ${this.$t('extra')}`
      } else {
        return result
      }
    },
    getBarTotalCountYear () {
      let data = this.$store.state.healthyHabits.chart.dataMapped
      let dataKeys = Object.keys(data)
      let firstYearDate = new Date(new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0))
      let lastYearDate = new Date(new Date(new Date().getFullYear(), 11, 31).setHours(0, 0, 0, 0))
      let result = dataKeys.reduce((acc, date) => { if (this.checkValidDate(date) && data[date] && firstYearDate <= new Date(date) && new Date(date) <= lastYearDate) { return data.measurable ? acc += data[date] : acc += 1 } else { return acc } }, 0)
      if (result > this.getYearlyMaxGoal) {
        let partial = (result - this.getYearlyMaxGoal) % 1 === 0 ? result - this.getYearlyMaxGoal : (result - this.getYearlyMaxGoal).toFixed(2)
        return `${this.getYearlyMaxGoal} + ${partial} ${this.$t('extra')}`
      } else {
        return result
      }
    },
    showMobileStreaks () {
      return this.mobileVersion()
    }
   },
   mixins: [healthyHabitsMixin],
   data () {
    return {
      newKeyOption: null,
      intervalOptionsScore: [{value: 0, text: this.$t('day')}, {value: 1, text: this.$t('week')}, {value: 2, text: this.$t('month')}, {value: 3, text: this.$t('year')}],
      intervalOptions: [{value: 1, text: this.$t('week')}, {value: 2, text: this.$t('month')}, {value: 3, text: this.$t('year')}],
      currentSliderPosition: 1
    }
   },
   methods: {
    getBarValueFixed (data) {
      if (!data) {
        return 0
      }
      return data % 1 === 0 ? data : data.toFixed(2)
    },
    sliderClick (arrowDirection) {
      if (arrowDirection === 0) {
        this.currentSliderPosition = this.currentSliderPosition === 1 ? 3 : this.currentSliderPosition === 3 ? 2 : 1
      } else if (arrowDirection === 1) {
        this.currentSliderPosition = this.currentSliderPosition === 1 ? 2 : this.currentSliderPosition === 2 ? 3 : 1
      }
    },
    showMoreSlider () {
      this.currentSliderPosition = this.currentSliderPosition === 1 ? 2 : this.currentSliderPosition === 2 ? 3 : 1
    }
   }
}
</script>

<style lang="scss">
.b-progress-statistics {
    width: 50% !important;
    display: inline-flex;
    @include media(mobile, tablets) {
        width: 100% !important;
    }
}
.interval-selector{
  width: auto; 
  float: right;
  margin-right: 3vw;
}
.interval-selector-container{
  display: flow-root;
}
/*pie style start*/
@property --p{
  syntax: '<number>';
  inherits: true;
  initial-value: 1;
}

.pie {
  --p:20;      /* the percentage */
  --b:22px;    /* the thickness */
  --c:darkred; /* the color */
  --w:75px;   /* the size*/
  
  width:var(--w);
  aspect-ratio:1/1;
  position:relative;
  display:inline-grid;
  margin:5px;
  place-content:center;
  font-size:20px;
  font-weight:bold;
  font-family:sans-serif;
}
.pie:before,
.pie:after {
  content:"";
  position:absolute;
  border-radius:50%;
}
.pie:before {
  inset:0;
  background:
    radial-gradient(farthest-side,var(--c) 98%,#0000) top/var(--b) var(--b) no-repeat,
    conic-gradient(var(--c) calc(var(--p)*1%), $gray-400 calc(var(--p)*1%));
  -webkit-mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
          mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
}
.pie:after {
  inset:calc(50% - var(--b)/2);
  background:var(--c);
  transform:rotate(calc(var(--p)*3.6deg - 90deg)) translate(calc(var(--w)/2 - 50%));
}
.animate {
  animation:p 1s .5s both;
}
.no-round:before {
  background-size:0 0,auto;
}
.no-round:after {
  content:none;
}
@keyframes p{
  from{--p:0;}
}
/*pie style end*/
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabitsStatisticsComponents.vue